import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      note:'首页',
      component: () => import('@/views/Home')
    }
    // {
    //   path: '/play',
    //   name: 'play',
    //   note:'播放页',
    //   component: () => import('@/views/player')
    // },
    // {
    //   path: '/data-detail/:uid',
    //   name: 'dataDetail',
    //   note:'实时数据详情',
    //   component: () => import('@/views/dataDetail')
    // },
    // {
    //   path: '/list/:type/:name',
    //   name: 'list',
    //   note:'数据列表',
    //   component: () => import('@/views/list')
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   note:'登录',
    //   component: () => import('@/views/login')
    // },
    // {
    //   path: '/user-login',
    //   name: 'userLogin',
    //   note:'登录确认',
    //   component: () => import('@/views/userLogin')
    // },
    // {
    //   path: '/demo',
    //   name: 'demo',
    //   component:  {
    //     template: Home,
    //     beforeRouteEnter(to, from, next){
    //       console.log('next: ',next)
    //     }
    //   }
    // },
  ]
})
